'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _theme = require('../../constant/theme');

exports.default = {
  props: {
    mode: {
      type: String,
      default: 'common'
    },
    type: {
      type: String,
      default: 'text'
    },
    size: {
      type: String,
      default: 'middle'
    },
    theme: {
      type: String,
      default: 'primary'
    },
    themeColor: {
      type: String,
      default: null
    },
    circleBlankColor: {
      type: String,
      default: '#f9f9f9'
    },
    text: {
      type: String,
      default: 'text'
    },
    textColor: {
      type: String,
      default: null
    },
    imgUrl: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasDot: {
      type: Boolean,
      default: false
    },
    hasAnimation: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    wrapperStyleComp: function wrapperStyleComp() {
      var disabled = this.disabled;

      if (disabled) {
        return {
          opacity: 0.3
        };
      } else {
        return {
          opacity: 1
        };
      }
    },
    btnWrapperStyle: function btnWrapperStyle() {
      var circleBlankColor = this.circleBlankColor,
          size = this.size;

      if (size === 'min') {
        return {
          padding: '4px'
        };
      } else {
        return {
          backgroundColor: circleBlankColor,
          padding: '10px',
          borderRadius: '70px'
        };
      }
    },
    btnSizeComp: function btnSizeComp() {
      var size = this.size,
          themeColor = this.themeColor,
          theme = this.theme;

      var colorSetArr = Object.keys(_theme.themeColors);
      var curColor = colorSetArr.includes(theme) ? _theme.themeColors[theme] : '#ffffff';
      if (size === 'min') {
        return {
          width: '88px',
          height: '88px',
          borderRadius: '44px',
          backgroundColor: themeColor ? themeColor : curColor
        };
      } else {
        return {
          width: '128px',
          height: '128px',
          borderRadius: '64px',
          backgroundColor: themeColor ? themeColor : curColor
        };
      }
    },
    btnImgSizeComp: function btnImgSizeComp() {
      var size = this.size;

      if (size === 'min') {
        return {
          width: '48px',
          height: '48px',
          borderRadius: '24px'
        };
      } else {
        return {
          width: '72px',
          height: '72px',
          borderRadius: '36px'
        };
      }
    },
    iconColor: function iconColor() {
      var themeColor = this.themeColor,
          theme = this.theme;

      var colorSetArr = Object.keys(_theme.themeColors);
      var curColor = colorSetArr.includes(theme) ? _theme.themeColors[theme] : '#ffffff';
      return themeColor ? themeColor : curColor;
    },
    textColorComp: function textColorComp() {
      var textColor = this.textColor,
          theme = this.theme;

      var defaultColor = '#232323',
          whiteText = '#ffffff';
      var curTextColor = textColor ? textColor : theme === 'white' ? defaultColor : whiteText;
      return {
        color: curTextColor
      };
    }
  },
  methods: {
    btnClickedHandler: function btnClickedHandler() {
      var disabled = this.disabled;

      !disabled && this.$emit('dofButtonClicked');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-circle-button/index.vue
// module id = 315
// module chunks = 0 1